import { render, staticRenderFns } from "./SoportePage.vue?vue&type=template&id=333721c8&scoped=true"
import script from "./SoportePage.vue?vue&type=script&lang=js"
export * from "./SoportePage.vue?vue&type=script&lang=js"
import style0 from "./SoportePage.vue?vue&type=style&index=0&id=333721c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333721c8",
  null
  
)

export default component.exports